import { render, staticRenderFns } from "./PlaceImagesModal.vue?vue&type=template&id=339ae610"
import script from "./PlaceImagesModal.vue?vue&type=script&lang=js"
export * from "./PlaceImagesModal.vue?vue&type=script&lang=js"
import style0 from "./PlaceImagesModal.vue?vue&type=style&index=0&id=339ae610&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339ae610')) {
      api.createRecord('339ae610', component.options)
    } else {
      api.reload('339ae610', component.options)
    }
    module.hot.accept("./PlaceImagesModal.vue?vue&type=template&id=339ae610", function () {
      api.rerender('339ae610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/PlaceImagesModal.vue"
export default component.exports